import { ChainId } from '@ui/types/chain';
import { Address } from 'viem';

import { ExchangePool } from '../types';

// Adapter Address

// Router & Quoter
const ROUTER_TESTNET = '0x1b81D678ffb9C0263b24A97847620C99d213eB14';
const QUOTER_TESTNET = '0x4c650FB471fe4e0f476fD3437C3411B1122c4e3B';
const ADAPTER_TESTNET = '0x562729a9240d031a2c5ee6381a5A02aFCF834F25';

// Mainnet (Assuming same for now, update if different)
const ROUTER_MAINNET = '0x1b81D678ffb9C0263b24A97847620C99d213eB14';
const QUOTER_MAINNET = '0x4c650FB471fe4e0f476fD3437C3411B1122c4e3B';
const ADAPTER_MAINNET = '0xD7Ae751ec282f90Af794738F80909D0E94B4908b';

// Fees: 0.01%, 0.05%, 0.25%, 1%
const FEES = [100, 500, 2500, 10000]; 

const createPools = (
  chainId: ChainId, 
  router: Address, 
  quoter: Address,
  adapter: Address
): ExchangePool[] => {
  return FEES.map((fee) => ({
    name: `Pancakeswap V3 ${fee / 10000}%`,
    adapter,
    router,
    quoter,
    fee,
    type: 'v3',
    icon: '/images/pancakeswap.svg',
  }));
};

export const PANCAKESWAP_V3_POOLS: Record<ChainId, ExchangePool[]> = {
  [ChainId.MONAD_MAINNET]: createPools(ChainId.MONAD_MAINNET, ROUTER_MAINNET, QUOTER_MAINNET, ADAPTER_MAINNET),
  [ChainId.MONAD_TESTNET]: createPools(ChainId.MONAD_TESTNET, ROUTER_TESTNET, QUOTER_TESTNET, ADAPTER_TESTNET),
};

